import { Modal } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ModalStyled = styled(Modal)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const MainStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  width: 350,
  padding: 24,
  borderRadius: 5,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 24,
  '& h3': {
    fontFamily: 'montserrat',
  },
}));

export const TitleStyled = styled('h3')(({ theme }) => ({
  ...theme.typography.h3,
}));

export const ButtonsContainerStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '80%',
  justifyContent: 'space-between',
  '& button': {
    width: 110,
    height: 48,
  },
  '& .save': {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.global.white,
    fontWeight: theme.typography.button.fontWeight,
    fontSize: theme.typography.button.fontSize,
  },
}));
